import React, { FC } from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { IconButton, Tooltip } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import Link from './Link'

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
`

type ActionButtonProps = {
  url?: string
  IconComponent: FC<{
    mode: string
    color: string
    fontSize: number
  }>
  tooltipContent?: string
}

const ActionButton = ({ url, IconComponent, tooltipContent }: ActionButtonProps) => {
  const displayTheme = useDisplayTheme()
  const iconColor = sys[displayTheme].interaction.primary.default
  return (
    <Tooltip mode={displayTheme} content={tooltipContent}>
      <IconButton mode={displayTheme}>
        <StyledLink
          href={url}
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation()
          }}>
          <IconComponent mode={displayTheme} color={iconColor} fontSize={14} />
        </StyledLink>
      </IconButton>
    </Tooltip>
  )
}

export default ActionButton
